import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import NoResultComponent from './NoResultComponent'
import { showNewShopTiresModal } from 'components/NewShopTiresModal/actions.js'
import { GENERAL_SOURCE, YMME_NAME } from 'constant'
import { getCurrentStore } from 'selectors'
import { showStoreLocatorModal } from 'actions/storeLocator'

const mapStateToProps = state => ({
  hasStore: getCurrentStore(state)
})

const withSwitchVehicleHandlers = withHandlers(({ showNewShopTiresModal }) => ({
  addVehicle: () => showNewShopTiresModal({
    isOnlyVehicle: true,
    ymmeName: YMME_NAME,
    withShowConfirmTireSizeModal: true,
    source: GENERAL_SOURCE
  })
}))

export default compose(
  connect(mapStateToProps, { showNewShopTiresModal, showStoreLocatorModal }),
  withSwitchVehicleHandlers
)(NoResultComponent)
